import {conf} from '../AppConf'
import * as _ from 'lodash';

export interface SiteFilterData {
  id: number,
  url: string
}

export interface SentimentDataTO {
  date: string,
  sentiment: number
}

export interface SiteSentimentTO {
  siteId: number,
  data: [SentimentDataTO]
}

export interface MinMaxDateTO {
  min?: string,
  max?: string
}

export interface UserTO {
  id: number,
  email: string
}

export const signIn = (email: string, pws: string): Promise<UserTO> =>
  api<UserTO>("/api/v1/auth/sign-in", {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({email, pws})
  } as RequestInit)

export const logOutRequest = (): Promise<string> =>
  api<string>( "/api/v1/auth/log-out", {
    method: 'POST',
    mode: 'cors'
  } as RequestInit)

export const getSiteFilterData = (): Promise<SiteFilterData[]> =>
  api<SiteFilterData[]>("/api/v1/report/sentiment/filter/site")

export const getMinMaxPublishedDate = (siteIds: number[]): Promise<MinMaxDateTO> => {
  let queryParam = ""
  if (siteIds.length > 0) {
    let ids = _.join(siteIds, ',')
    queryParam = `?siteIds=${ids}`
  }

  return api<MinMaxDateTO>(`/api/v1/report/sentiment/filter/min-max-date${queryParam}`)
}

export const getArticlesSentimentData = (
  startMonth: number,
  startYear: number,
  endYear: number,
  siteIds: number[],
  keyword?: string
): Promise<SiteSentimentTO[]> => {
  if (siteIds.length === 0 || startYear > endYear) {
    return Promise.resolve([]);
  }
  let ids = _.join(siteIds, ',');
  let keywordParam = keyword
    ? `&keyword=${encodeURIComponent(keyword)}`
    : '';
  return api<SiteSentimentTO[]>(`/api/v1/report/sentiment?startMonth=${startMonth}&startYear=${startYear}&endYear=${endYear}&siteIds=${ids}${keywordParam}`)
}

function api<T>(url: string, opt?: RequestInit): Promise<T> {
  return fetch(conf.rest.reportUrl + url, opt)
    .then(response => {
      if (!response.ok) {
        try {
          return response.clone().json().then(a => {
            if (a.description) {
              return Promise.reject(a.description)
            } else {
             return Promise.reject(response.statusText)
            }
          })
        } catch  {
          throw new Error(response.statusText)
        }
      }
      return response.json() as Promise<T>
    })
}
